import angular from 'angular';
import pqrsDetailComponent from './pqrs-detail.component';
import PqrsDetailService from './pqrs-detail.service';
import pqrsDetailConfig from './pqrs-detail.config';
import PqrsResponsableModalController from './pqrs-responsable-modal/pqrs-responsable-modal.controller';
import PqrsInnerModalController from './pqrs-inner-modal/pqrs-inner-modal.controller';
import PqrsDetailModalController from './pqrs-detail-modal/pqrs-detail-modal.controller';

let pqrsDetailModule = angular.module('app.pqrsDetail',[])
  .component('pqrsDetail', pqrsDetailComponent)
  .service('PqrsDetailService', PqrsDetailService)
  .controller('PqrsResponsableModalController', PqrsResponsableModalController)
  .controller('PqrsDetailModalController', PqrsDetailModalController)
  .controller('PqrsInnerModalController', PqrsInnerModalController)
  .config(pqrsDetailConfig);

export default pqrsDetailModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pqrs/pqrs-detail/pqrs-detail.js
 **/